import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

import styled from 'styled-components';
import IconButton from './IconButton';
import Text from './Text';
import Flex from './Flex';

interface Props {
    onBack: () => void;
    label?: string;
    testId?: string;
    disabled?: boolean;
}

const BackButton: React.FC<Props> = ({ onBack, label, testId, disabled }) => {
    return (
        <StyledContainer align="center">
            <StyledIconButton disabled={disabled} data-testid={testId} onClick={onBack} icon={faArrowLeft} />
            <StyledLabel disabled={disabled} as="label">
                {label}
            </StyledLabel>
        </StyledContainer>
    );
};

export default BackButton;

const StyledLabel = styled(Text)<{ disabled?: boolean }>`
    padding: 7px;
    color: ${({ theme, disabled }) => (disabled ? theme.colors.textDisabled : theme.colors.text)};
`;

const StyledIconButton = styled(IconButton)`
    background-color: ${({ theme }) => theme.colors.fillWhite};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

const StyledContainer = styled(Flex)`
    border-radius: var(--radius);
    cursor: pointer;
`;
